import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';

import styles from './styles.js';

class IndentedCardHeader extends React.Component {
  render() {
    const {
      classes,
      title,
      avatar,
      action,
      actionHeader,
      restrictHeader,
      section,
    } = this.props;

    const titleNode =
      title.type == Typography ? (
        <span className={`${classes.title} CardHeaderTitle`}>{title}</span>
      ) : (
        title
      );

    return (
      <CardHeader
        title={titleNode}
        avatar={avatar}
        action={action}
        className="CardHeader"
        onClick={actionHeader ? actionHeader : null}
        classes={{
          root: actionHeader
            ? `${classes.root} ${classes.actionHeader}`
            : restrictHeader
            ? `${classes.root} ${classes.restrictHeader}`
            : `${classes.root}`,
          avatar:
            section == 'appointments'
              ? `${classes.avatar} ${classes.appointments} CardIcon`
              : section == 'workRequests'
              ? `${classes.avatar} ${classes.workRequests} CardIcon`
              : section == 'accounts'
              ? `${classes.avatar} ${classes.accounts} Card Icon`
              : `${classes.avatar} CardIcon`,
          action: classes.action,
        }}
      />
    );
  }
}

IndentedCardHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.object.isRequired,
  avatar: PropTypes.object.isRequired,
  action: PropTypes.object,
  actionHeader: PropTypes.func,
  restrictHeader: PropTypes.bool,
  section: PropTypes.string,
};

IndentedCardHeader.defaultProps = {
  action: null,
  actionHeader: null,
  restrictHeader: false,
};

export default withStyles(styles)(IndentedCardHeader);
